<template>
    <v-tooltip z-index="400" location="top" :max-width="500">
        <template v-slot:activator="{ props }">
            <v-icon v-bind="props" color="primary" size="20">
                mdi-information-outline
            </v-icon>
        </template>
        <span>{{ params.tooltipText }}</span>
    </v-tooltip>
</template>

<script>
export default {};
</script>
